{ doAction, fail, success } = require './index'

FAILED_CREATE_MESSAGE = 'Failed to create a new school'
SUCCEEDED_CREATE_MESSAGE = 'School created'
CREATED_SCHOOL = 'CREATED_SCHOOL'
CREATING_SCHOOL = 'CREATING_SCHOOL'

FAILED_DELETE_MESSAGE = 'Deletion failed'
SUCCEEDED_DELETE_MESSAGE = 'School deleted'
DELETED_SCHOOL = 'DELETED_SCHOOL'
DELETING_SCHOOL = 'DELETING_SCHOOL'

FAILED_FETCH_MESSAGE = 'Failed to retrieve the list of schools from the server'
FETCHED_SCHOOLS = 'FETCHED_SCHOOLS'
FETCHING_SCHOOLS = 'FETCHING_SCHOOLS'

SELECT_SCHOOL = 'SELECT_SCHOOL'

FAILED_UPDATE_MESSAGE = 'Update failed'
SUCCEEDED_UPDATE_MESSAGE = 'School updated'
UPDATED_SCHOOL = 'UPDATED_SCHOOL'
UPDATING_SCHOOL = 'UPDATING_SCHOOL'

url = '/api/schools'

module.exports = {
	FAILED_CREATE_MESSAGE
	CREATED_SCHOOL
	CREATING_SCHOOL

	FAILED_DELETE_MESSAGE
	DELETED_SCHOOL
	DELETING_SCHOOL

	FAILED_FETCH_MESSAGE
	FETCHED_SCHOOLS
	FETCHING_SCHOOLS

	SELECT_SCHOOL

	FAILED_UPDATE_MESSAGE
	UPDATED_SCHOOL
	UPDATING_SCHOOL

	createSchool: (school) ->
		method = 'post'
		payload = school
		doingActionType = CREATING_SCHOOL
		didActionType = CREATED_SCHOOL
		failureMessage = FAILED_CREATE_MESSAGE
		successMessage = SUCCEEDED_CREATE_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	deleteSchool: (schoolId) ->
		endpoint = url + "/#{school.id}"
		method = 'delete'
		payload = { id: schoolId }
		doingActionType = DELETING_SCHOOL
		didActionType = DELETED_SCHOOL
		failureMessage = FAILED_DELETE_MESSAGE
		successMessage = SUCCEEDED_DELETE_MESSAGE
		doAction(endpoint, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	fetchSchools: ->
		method = 'get'
		payload = null
		doingActionType = FETCHING_SCHOOLS
		didActionType = FETCHED_SCHOOLS
		failureMessage = FAILED_FETCH_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage)

	selectSchool: (school) ->
		type: SELECT_SCHOOL
		payload:
			school: school

	updateSchool: (school) ->
		endpoint = url + "/#{school.id}"
		method = 'PATCH'
		payload = school
		doingActionType = UPDATING_SCHOOL
		didActionType = UPDATED_SCHOOL
		failureMessage = FAILED_UPDATE_MESSAGE
		successMessage = SUCCEEDED_UPDATE_MESSAGE
		doAction(endpoint, method, payload, doingActionType, didActionType, failureMessage, successMessage)
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/schools.coffee